<section class="operations-page">
    <header class="operations-page__header">
        <div>
            <h2 class="operations-page__title">Providers</h2>
            <p class="operations-page__lead">
                Supported vision providers discovered from the platform subscription APIs.
            </p>
        </div>
        <div class="operations-actions">
            <button type="button" class="operations-btn" [disabled]="loading" (click)="loadProviders()">
                Refresh
            </button>
        </div>
    </header>

    <div class="operations-page__card" *ngIf="loading">
        <p class="operations-page__loading">Loading providers…</p>
    </div>

    <div class="operations-page__card" *ngIf="!loading && !providers.length">
        <p class="operations-page__empty">No vision providers are currently available.</p>
    </div>

    <div class="provider-grid" *ngIf="!loading && providers.length">
        <a *ngFor="let provider of providers"
           class="provider-card"
           [routerLink]="['/vision-configuration/provider-management/providers', provider.provider_id, 'overview']">
            <div class="operations-actions operations-actions--spread">
                <h3 class="provider-card__title">{{ provider.provider_label }}</h3>
                <span [class]="statusClass(provider.health_status)">{{ provider.health_label }}</span>
            </div>
            <div class="provider-card__meta">
                <div>Provider ID: {{ provider.provider_id }}</div>
                <div>Authentication: {{ provider.oauth_configured ? 'Configured' : 'Not configured' }}</div>
                <div>Active subscriptions: {{ provider.active_subscription_count }}</div>
                <div>Last synchronization: {{ formatTimestamp(provider.last_synchronized_at) }}</div>
            </div>
        </a>
    </div>
</section>
